import { useEffect } from 'react'
import { useConsentManager } from '@/hooks/useConsentManager'

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void
    dataLayer: unknown[]
  }
}

export function GtagConsentSync() {
  const { preferences, consentStatus } = useConsentManager()

  useEffect(() => {
    if (!preferences) return
    if (typeof window.gtag !== 'function') return

    window.gtag('consent', 'update', {
      analytics_storage: consentStatus.hasAnalytics ? 'granted' : 'denied',
      ad_storage: consentStatus.hasMarketing ? 'granted' : 'denied',
      ad_user_data: consentStatus.hasMarketing ? 'granted' : 'denied',
      ad_personalization: consentStatus.hasMarketing ? 'granted' : 'denied',
    })
  }, [preferences, consentStatus.hasAnalytics, consentStatus.hasMarketing])

  return null
}
